import { useState } from 'react';
import { ErrorOutlined } from '@mui/icons-material';

import Button from 'components/library/Button/Button';
import styles from './ConfirmationError.module.css';
import { redirectToSignature } from 'services/network/api/payment';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { logError } from 'utils/logs';

export default function ConfirmationError() {
  const [status, setStatus] = useState('IDLE');
  const [error, setError] = useState<Error | undefined>(undefined);

  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const signDocument = async () => {
    setStatus('LOADING');
    try {
      const { data } = await redirectToSignature(parseInt(id || '0'));
      setStatus('SUCCESS');
      window.setTimeout(() => document.location.replace(data.url), 1000);
    } catch (err) {
      logError(err as Error);
      setError(err as Error);
      setStatus('ERROR');
    }
  }
  return (
    <div className={styles.background}>
      <section className={styles.modal}>
        <div className={styles.illustration}>
          <ErrorOutlined className={styles.icon} />
        </div>
        <p
          className={styles.title}
          data-cy="confirmation-error-title"
        >
          {t('coordonnate.loi.title')}
        </p>
        <p className={styles.description}>
          {t('coordonnate.loi.description')}
        </p>
        {
          (error)
          && (
            <details>
              {error.toString()}
            </details>
          )
        }
        <Button
          className={styles.button}
          label={(status !== 'IDLE') ? t('coordonnate.loi.redirect') : t('coordonnate.loi.try')}
          disabled={(status === 'LOADING')}
          onButtonClick={signDocument}
          dataCy="confirmation-error-loi-redirect"
        />
        {
          (status === 'IDLE')
          && (
            <Button
              label={t('coordonnate.loi.back')}
              className={styles.button}
              variant="ghost"
              onButtonClick={() => navigate(`/${id}/confirmation`)}
              dataCy="confirmation-error-loi-back"
            />
          )
        }
      </section>
    </div>
  );
}
